import { Link } from 'react-router-dom';

export default function FreeSEOToolsPage() {
  const tools = [
    { icon: '🔍', title: 'Keyword Research Tool', desc: '200+ ideas, volume, KD, CPC', link: '/keyword-research-tool' },
    { icon: '🔗', title: 'Backlink Checker', desc: '2.5T backlink index, authority', link: '/backlink-checker' },
    { icon: '🌐', title: 'Domain Overview', desc: 'Authority, traffic, keywords', link: '/domain/overview' },
    { icon: '📊', title: 'Organic Research', desc: 'All organic keywords', link: '/domain/organic' },
    { icon: '⚡', title: 'Site Audit Tool', desc: '130+ checks, Core Web Vitals', link: '/site-audit-tool' },
    { icon: '📝', title: 'On Page Checker', desc: 'Optimize for keyword', link: '/audit/onpage' },
    { icon: '🎯', title: 'Keyword Gap', desc: 'Steal competitor keywords', link: '/keywords/gap' },
    { icon: '💎', title: 'Backlink Gap', desc: 'Find link opportunities', link: '/backlinks/gap' },
  ];

  return (
    <div style={{ background: 'white', minHeight: '100vh' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '40px 24px' }}>
        <div style={{ textAlign: 'center', maxWidth: 800, margin: '0 auto 40px' }}>
          <div style={{ display: 'inline-flex', background: '#E6F9ED', color: '#007A33', fontSize: 11, fontWeight: 700, padding: '4px 12px', borderRadius: 99, marginBottom: 16 }}>FREE SEO TOOLS</div>
          <h1 style={{ fontSize: 48, fontWeight: 800, lineHeight: 1.1, letterSpacing: '-0.03em', marginBottom: 16 }}>Free SEO Tools</h1>
          <p style={{ fontSize: 18, color: '#6B7280', lineHeight: 1.5, marginBottom: 24 }}>Keyword research, backlink analysis, site audits, and more — all built on real DataForSEO data. Free credits on signup, no credit card required.</p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
            <Link to="/dashboard" className="btn btn-lg" style={{ background: '#FF642D', color: 'white', height: 48, padding: '0 24px' }}>Try Free SEO Tools →</Link>
            <Link to="/pricing" className="btn btn-lg btn-white" style={{ height: 48 }}>See Pricing</Link>
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: 16, marginBottom: 40 }}>
          {tools.map(t => (
            <Link key={t.title} to={t.link} style={{ textDecoration: 'none', color: 'inherit' }}>
              <div className="card" style={{ margin: 0, height: '100%' }}>
                <div style={{ fontSize: 24, marginBottom: 8 }}>{t.icon}</div>
                <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 4 }}>{t.title}</div>
                <div style={{ fontSize: 12, color: '#6B7280' }}>{t.desc}</div>
                <div style={{ marginTop: 8, fontSize: 11, color: '#FF642D', fontWeight: 700 }}>Try Free →</div>
              </div>
            </Link>
          ))}
        </div>

        <div style={{ maxWidth: 800, margin: '0 auto', background: '#111', color: 'white', borderRadius: 12, padding: 24, textAlign: 'center' }}>
          <div style={{ fontWeight: 800, fontSize: 20, marginBottom: 8 }}>Every tool in one place</div>
          <div style={{ fontSize: 13, color: '#9CA3AF', marginBottom: 16 }}>Free credits on signup, no card required</div>
          <Link to="/" className="btn" style={{ background: '#FF642D', color: 'white' }}>Start Free →</Link>
        </div>
      </div>
    </div>
  );
}
